module.exports = __webpack_public_path__ + "img/BG_ALT_04.da4eafb7.png";